import { api } from "./api";

export const getCondicao = (numeroPagina: string) =>
  api.get(`Condicao/buscartodos/${numeroPagina}`);
  export const getCondicaoCd = (cd: number) => api.get(`Condicao/buscar/${cd}`);
export const getTodasCondicoes = async () => {
  try {
      const response = await api.get(`Condicao/select`)
      return response.data;
  } catch (error) {
    console.error(error);
  }
};
